export default __webpack_public_path__ + "static/media/m1.101f8dab.jpg";